<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg6" alt="" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/rocktloan.aurorafinsynergy/components/img/about1.png";
import importedImg2 from "@/page/rocktloan.aurorafinsynergy/components/img/about2.png";
import importedImg3 from "@/page/rocktloan.aurorafinsynergy/components/img/about3.png";
import importedImg4 from "@/page/rocktloan.aurorafinsynergy/components/img/about4.png";
import importedImg5 from "@/page/rocktloan.aurorafinsynergy/components/img/about5.png";
import importedImg6 from "@/page/rocktloan.aurorafinsynergy/components/img/about6.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background: #FCFCFC;
}
img {
  display: block;
}
.flexBox{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem {
  width: 100%;
  margin: 0;
}

.flexBox:nth-child(2) .imgBox,
.flexBox:nth-child(4) .imgBox,
.flexBox:nth-child(5) .imgBox,
.flexBox:nth-child(6) .imgBox {
  padding: 80px 200px;
}


</style>
